import { useFormContext } from "react-hook-form";
import { CopyOidcUrl } from "./CopyOidcUrl";
import { CopySamlUrl } from "./CopySamlUrl";

export const CopySsoRedirectUrl = ({
  logtoConnectorId,
  domainName,
  ssoDetails,
}: {
  logtoConnectorId?: string;
  domainName?: string;
  ssoDetails?: any;
}) => {
  const logtoEndpoint = import.meta.env.VITE_LOGTO_ENDPOINT;
  const logtoEndpointWithSlash = logtoEndpoint.endsWith("/")
    ? logtoEndpoint
    : `${logtoEndpoint}/`;

  let newLogtoConnectorId = "";
  if (logtoConnectorId) {
    newLogtoConnectorId = logtoConnectorId;
  } else if (ssoDetails && ssoDetails?.length > 0 && domainName) {
    newLogtoConnectorId = ssoDetails?.find(
      (ssoDetail: any) => ssoDetail?.domain_name === domainName,
    )?.logto_connector_id;
  }

  const redirectUrl = `${logtoEndpointWithSlash}callback/${newLogtoConnectorId}`;
  const assertionConsumerServiceUrl = `${logtoEndpointWithSlash}api/authn/single-sign-on/saml/${newLogtoConnectorId}`;
  const audienceUri = `${logtoEndpointWithSlash}enterprise-sso/${newLogtoConnectorId}`;

  const { watch } = useFormContext();
  const watchType = watch("type");

  return watchType === "OIDC" ? (
    <CopyOidcUrl redirectUrl={redirectUrl} />
  ) : watchType === "SAML" ? (
    <CopySamlUrl
      assertionUrl={assertionConsumerServiceUrl}
      audienceUri={audienceUri}
    />
  ) : (
    <></>
  );
};
